export default __webpack_public_path__ + "static/media/5.fac7f5e1.webp";